// src/components/GoogleMapsLoader.js
import { useEffect, useState } from 'react';

const GoogleMapsLoader = ({ apiKey, children, loadingComponent }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const existingScript = document.getElementById('googleMaps');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.id = 'googleMaps';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      script.onload = () => {
        setIsLoaded(true);
      };
    } else {
      setIsLoaded(true);
    }
  }, [apiKey]);

  return isLoaded ? children : loadingComponent;
};

export default GoogleMapsLoader;
